/*import {
  imagesDir
} from './../../../providers/global.config';*/
import {
  NavController,
  NavParams,
  AlertController,
  ModalController,
  LoadingController,
  ViewController,
  MenuController,
  ToastController
} from 'ionic-angular';
import {
  Component
} from '@angular/core';
import {
  DataManagementService
} from './../../../providers/data-management.service';
import {
  GroupService
} from '../../../providers/group.service';
import {
  Groupe
} from '../../../objects/index';

@Component({
  selector: 'page-groupes',
  templateUrl: 'groupes.html',
})
export class Groupes {
  public maxSize: number = 5;
  public bigTotalItems: number = 175;
  public bigCurrentPage: number = 1;
  public numPages: number = 0;
  itemsPerPage = 25;
  groups: Groupe[] = [];
  //imagesDir: any = imagesDir;
  constructor(public menu: MenuController, private groupeService: GroupService) {

  }
  //Get list groups
  ngOnInit() {
    this.getListGroups(this.bigCurrentPage - 1, this.itemsPerPage);
    this.groupeService.getVehiculesMatricules().subscribe(response => {
      this.groupeService.vehiculeLabels = response;
    });
  }
  //Open Menu
  openmenu() {
    this.menu.open();

  }
  //
  getListGroups(page: number, size: number) {
    this.groupeService.bigCurrentPage = this.bigCurrentPage;
    this.groupeService.getGroupsByPageAndSize(this.bigCurrentPage - 1, this.itemsPerPage).subscribe(groups => {
      this.groups = groups.content;
      this.groupeService.groups = this.groups;
      this.bigTotalItems = groups.totalElements;

    });
  }
  //end
}



// WEBPACK FOOTER //
// ./src/pages/datamana/groupes/groupes.ts